import React from "react";

import { PageHead } from "utils/page-head";
import { TITLE } from "constant/app.page-title";

import HeroSection from "./components/hero-section/hero-section";
import BrandSection from "./components/brand-section/brand-section";
import DiscussSection from "./components/discuss-section/discuss-section";
import SolutionSection from "./components/solution-section/solution-section";
import MarketingSection from "./components/marketing-section/marketing-section";

const Homepage = () => {
  return (
    <>
      <PageHead title={TITLE.HOMEPAGE} />

      <HeroSection />
      <BrandSection />
      <SolutionSection />
      <MarketingSection />
      <DiscussSection />
    </>
  );
};

export default Homepage;
